import { useContext } from "react";
import styled, { css } from "styled-components";
import { truncateWithEllipsis } from "../../services/Utils";
import WorkspaceContext from "../WorkSpace/WorkspaceContext";
import { MediaIcon } from "./BrandContacts";
const AddressStyle = styled.div`
  text-transform: capitalize;
  line-height: 1.1;
  background: linear-gradient(to right, #c20713ff, #ac0914ff);
  display: flex;
  p {
    margin-top: 0;
  }
  ${({ canvasScale, bgColor, color }) => css`
    font-size: ${20 * canvasScale}px;
    gap: ${25 * canvasScale}px;
    color: #ffffff;
    padding: ${2 * canvasScale}px;
    border-top-right-radius: ${25 * canvasScale}px;
    border-bottom-right-radius: ${25 * canvasScale}px;

    .icon {
      width: ${5 * canvasScale}rem;
      height: ${5 * canvasScale}rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .space {
      min-height: ${2 * canvasScale}rem;
    }
  `}
`;

export default function BrandAddress({ styles, canvasScale, className }) {
  const { userBrand } = useContext(WorkspaceContext);

  function getFormattedAddress(address) {
    if (!address) return "";
    const parts = [];
    if (address.street !== "") parts.push(`${address.street},`);
    if (address.number !== "") parts.push(`N° ${address.number}.`);
    if (address.neighborhood !== "") parts.push(`${address.neighborhood}.`);
    if (address.city) parts.push(address.city);
    return parts.join(" ");
  }

  return (
    <>
      {(userBrand && styles && userBrand.address?.street !== "") ||
      userBrand.address?.city !== "" ||
      userBrand.address?.neighborhood !== "" ||
      userBrand.address?.number !== "" ? (
        <AddressStyle
          canvasScale={canvasScale}
          className={`flex align ${className}`}
          bgColor={styles.bgColor}
          color={styles.txtColor}
        >
          <MediaIcon
            canvasScale={canvasScale}
            icon={"/icons/location_icon.png"}
            className="icon"
          />
          <p>
            {truncateWithEllipsis(getFormattedAddress(userBrand.address), 80)}
          </p>
        </AddressStyle>
      ) : (
        <div className="space"></div>
      )}
    </>
  );
}
